import Dexie from 'dexie'

/**
 * @typedef {'draft_local'|'queued'|'synced'|'exported'} IncidentLocalStatus
 * @typedef {'pending'|'processing'|'done'|'error'|'failed_permanent'} QueueStatus
 */

export class AdamsOfflineDB extends Dexie {
  /** @type {import('dexie').Table<{ id: string, refreshToken?: string, updatedAt: number }, string>} */
  localSessions

  /** @type {import('dexie').Table<{ id: string, init: Object, schemaVersion: string, storedAt: string }, string>} */
  initSnapshots

  /** @type {import('dexie').Table<{ clientUuid: string, status: IncidentLocalStatus, payload: Object, updatedAt: string, serverFinalId?: string }, string>} */
  localIncidents

  /** @type {import('dexie').Table<{ id?: number, clientUuid: string, operation: string, payload: Object, idempotencyKey: string, attempts: number, lastError?: string, status: QueueStatus, createdAt: string, nextRetryAt?: string, processingStartedAt?: string, deadLetteredAt?: string }, number>} */
  syncQueue

  /** @type {import('dexie').Table<{ key: string, data: unknown, updatedAt: string }, string>} */
  offlineData

  /** @type {import('dexie').Table<{ key: string, value: unknown }, string>} */
  meta

  constructor() {
    super('adamsOfflinePWA')
    this.version(1).stores({
      localSessions: 'id',
      initSnapshots: 'id',
      localIncidents: 'clientUuid, status, updatedAt',
      syncQueue: '++id, clientUuid, idempotencyKey, status'
    })
    this.version(2).stores({
      offlineData: 'key, updatedAt',
      meta: 'key'
    })
    this.version(3).stores({
      localSessions: 'id',
      initSnapshots: 'id',
      localIncidents: 'clientUuid, status, updatedAt',
      syncQueue:
        '++id, clientUuid, idempotencyKey, status, nextRetryAt, processingStartedAt, deadLetteredAt',
      offlineData: 'key, updatedAt',
      meta: 'key'
    })
  }
}

export const offlineDb = new AdamsOfflineDB()
